import { useEffect, useState } from 'react';

const DEFAULT_MAX = 767;

/**
 * true si la largeur viewport est au plus maxPx (défaut 767px, sous le breakpoint md Tailwind).
 */
export function useIsMobile(maxPx = DEFAULT_MAX) {
  const query = `(max-width: ${maxPx}px)`;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
